<template>
  <div class="changeinfo">
    <div class="mode_banner">
      <img src="@assets/images/new/banner.png" />
    </div>
    <div class="zhanwei"></div>
    <div class="change_info">
      <div class="div_input0">
        <span>用户名:</span>
        <input
          type="text"
          placeholder="请输入用户名"
          v-model="real_name"
          maxlength="30"
          :value="real_name"
        />
      </div>
      <div class="div_input0">
        <span>电话:</span>
        <input
          type="text"
          readonly="readonly"
          v-model="account"
          class="phone"
          :value="account"
          maxlength="11"
        />
      </div>
      <button @click="changeinfoSub" class="changeinfoSub">确认修改</button>
    </div>
  </div>
</template>

<script>
import { hcUpUserInfo, hcGetUserInfo } from "@api/user";
export default {
  name: "userChangeMyInfo",
  mixins: [],
  data: function() {
    return {
      real_name: "",
      account: ""
    };
  },
  mounted: function() {},
  created() {
    this.init();
  },
  methods: {
    // 进入页面初始更新数据
    init() {
      var that = this;
      hcGetUserInfo().then(res => {
        console.log("获取用户信息：", res);
        console.log(
          "res.data.UserInfo.real_name：",
          res.data.UserInfo.real_name
        );
        console.log("res.data.UserInfo.account：", res.data.UserInfo.account);
        that.real_name = res.data.UserInfo.real_name;
        that.account = res.data.UserInfo.account;
      });
    },
    changeinfoSub() {
      var that = this;
      if (that.real_name.trim().length < 2) {
        that.$dialog.message("姓名不能少于2个字");
        return;
      } else {
        hcUpUserInfo({ real_name: that.real_name }).then(data => {
          if (data.status == 400) {
            that.$dialog.error(data.msg);
          } else {
            console.log("返回正常");
            that.$dialog.message(data.msg);
            setTimeout(function() {
              window.location.href = "/user/hc_my";
            }, 1200);
          }
        });
      }
    }
  }
};
</script>

<style>
body {
  background-color: #fff !important;
}
.zhanwei {
  height: 0.4rem;
  width: 100%;
}
.changeinfo {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.mode_banner,
.mode_banner img {
  display: block;
  width: 100%;
}
.change_info {
  width: calc(100% - 0.6rem);
  margin: 0 auto;
}
.div_input0 {
  width: 100%;
  height: 0.97rem;
  background-color: #f3f4f8;
  display: flex;
  border-radius: 0.5rem;
  margin-bottom: 0.4rem;
}
.div_input0 span {
  padding-left: 0.31rem;
  display: block;
  height: 0.97rem;
  line-height: 0.97rem;
  color: #666666;
  font-size: 0.28rem;
  width: 1.8rem;
}
.div_input0 input::-webkit-input-placeholder {
  color: #a1a9b4;
  font-size: 0.28rem;
  width: calc(100% - 1.8rem - 0.31rem);
}
.changeinfoSub {
  display: block;
  width: 100%;
  color: #fff;
  height: 0.97rem;
  line-height: 0.97rem;
  background-color: #275caa;
  border-radius: 0.5rem;
  font-size: 0.32rem;
  margin-top: 0.78rem;
}
.phone {
  color: #999;
}
</style>
